<template>
    <div id="app">
        <!-- <div id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </div> -->
        <div :class="'view-screen w-limit '+ (!isWebview() ? 'view-original':'view-iframe')" id="view-screen">
            <router-view/>
			<template v-if="!isWebview()">
				<SOModalBeta
					:value="modalBeta"
					@close="closeModal()"
					:closable="true"
				/> 
			</template>
        </div>
        <bottom-menu v-if="requireAuth && !$store.state.metaModule.isWebview"></bottom-menu>
    </div>
</template>

<script>
	import { mapActions, mapMutations, mapState } from "vuex";
    import BottomMenu from "./components/onboarding/BottomMenu";
	import SOModalBeta from './so-components/global/modal/SOModalBeta.vue';
  import store from "@/store";
    export default {
        components: {
			BottomMenu,
			SOModalBeta
		},
        data() {
    		return {
			    showUpgradeUI: false,
                requireAuth:false,
			    requestHeaders: {
				    headers: {
					    'Authorization': 'Bearer ' + localStorage.getItem('token'),
				    }
			    },
		    }
	    },
		computed: {
			...mapState({
				modalBeta: state => state.metaModule.isOpenBetaModal,
			}),
		},
        watch: {
            '$route.meta.requireAuth': {
                handler: function (requireAuthMeta) {
                    this.requireAuth=requireAuthMeta
					// if (this.isDateModal()) {
					// 	this.showModalBeta()
					// }

	                setTimeout(() => {
		                this.layoutWithNav()
	                }, 50)

	                if(!this.requireAuth && !this.$store.state.metaModule.isWebview){
		                $(".view-screen").css('cssText', 'margin:0px auto; max-width: 600px !important');
		                $(".header-top").css('cssText', 'margin:0px auto; max-width: 600px !important');
	                }
                },
                deep: true,
                immediate: true
            },
        },
	    async mounted() {
			this.setInitRoute(this.$route.path)
			if(this.$store.state.metaModule.isWebview) window.addEventListener('message', this.receiveMessage)
        	$("#state-wait").hide();
        	$("#state-offline").hide();

            this.requireAuth=this.$route.meta.requireAuth
		    window.onpopstate = function() {
				if ("token" in localStorage) {
					if (this.$route.meta.notRequireAuth && this.$route.name!="subscribe") {
						this.fetchBetaFeature()
						this.fetchKomplainQrisMenu()
						this.$router.push("/")
					}
				}
		    };
	        if (this.$workbox) {
		        this.$workbox.addEventListener("waiting", () => {
			        this.showUpgradeUI = true;
		        });
	        }
            if (this.$route.meta.requireAuth) {

                if ("token" in localStorage) {
					this.fetchBetaFeature()
					this.fetchKomplainQrisMenu()
	                this.$router.push(this.$router.currentRoute.path)
                    await this.getOwnerToken();
                } else {
                    localStorage.setItem("redirect-path", this.$route.path)

                    this.$router.push("/startscreen")
                }
            } else {
	            if ("token" in localStorage && localStorage.getItem("token") !== "") {
		            if (!this.$route.meta.requireAuth && this.$route.name!="subscribe") {
						this.fetchBetaFeature()
						this.fetchKomplainQrisMenu()
						await this.getOwnerToken();
			            this.$router.push("/")
		            } else {
			            this.$router.push(this.$router.currentRoute.path)
		            }
	            }
            }
        },
	    methods: {
			...mapMutations({
				setOpenBetaModal: "metaModule/setOpenBetaModal",
			}),
			isDateModal() {
				const targetDate = new Date("2023-06-20T08:00:00+07:00")
				const dateNow = new Date()
				return dateNow > targetDate
			},
			showModalBeta() {
				if (!this.requireAuth) return
				this.setOpenBetaModal(false)
				setTimeout(() => {
					this.setOpenBetaModal(true)
				}, 200)
			},
			closeModal() {
				this.setOpenBetaModal(false)
			},
			setInitRoute(path) {
				if (this.isWebview()) {
					this.$store.commit("metaModule/setInitRoute", path)
				}
			},
		    async accept() {
			    this.showUpgradeUI = false
			    await this.$workbox.messageSW({ type: "SKIP_WAITING" });
		    },
			receiveMessage (event) {
                // olah data dan rotuingmu dari sini
				const obj = event.data
				console.log(obj);
				if (obj.type == 'data') {
					const data = obj.value
					if (data.name == 'acl') {
						// localStorage.setItem('acl_list', data.value.length ? JSON.stringify(data.value) : null)
					}
				}
				if (event.data.type == 'route') {
					this.setInitRoute(event.data.value)
					this.$router.push({ path: event.data.value })
				}
            },
		    layoutWithNav() {
		    	if ($(".navbar-container").is(":visible")) {
		    		if (!$(".view-screen").children().children().hasClass("vh-100")) {
					    $(".view-screen").css({"padding-bottom": $(".navbar-container").height()})
				    }

				    $('body').on('DOMSubtreeModified', '#app', () => {
					    setTimeout(() => {
						    $(".flex-100").css({"min-height": "calc(100vh - 72px)"})
						    // $(".flex-100 .flex-1").css({"margin-bottom": "20px"})
					    }, 100)
				    });
			    } else {
				    $(".view-screen").css({"padding-bottom": "0px"})

				    $('body').on('DOMSubtreeModified', '#app', () => {
					    setTimeout(() => {
						    $(".flex-100").css({"min-height": "100vh"})
						    // $(".flex-100 .flex-1").css({"margin-bottom": "0px"})
					    }, 100)
				    });
			    }
		    },
		    async getOwnerToken() {
			    try {
			    	var idowner = localStorage.getItem("idowner")
				    var token = localStorage.getItem("token")
				    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_owner_token' +
					    '?idowner=' + idowner +
					    '&token=' + token
				    );
				    var dataeach = response.data.data
				    if (response.data.code === 200) {
					    if (response.data.status === true) {
						    localStorage.setItem("remember-token-firebase", dataeach.token_firebase)
                await this.getNewUIStatus()

					    } else {
						    this.logoutApp()
					    }
				    } else {
					    this.$toast.error(response.data.msg)
				    }
			    } catch (e) {
				    if (e.response.data.code === 401) {
					    this.logoutApp()
					    // return
				    }
				    // if (!e.code) {
					//     this.$catch_error_response(e);
				    // }
			    }
		    },
		    async logoutApp() {
			    try {
				    const forms = new FormData;
				    forms.append("idowner", localStorage.getItem("idowner"))
				    forms.append("token", localStorage.getItem("token"))
				    const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/logout_owner_token', forms);
				    if (response.data.code === 200) {
					    if (response.data.status === true) {
						    this.forceLogout()
					    } else {
						    this.$toast.error(response.data.msg)
					    }
				    } else {
					    this.$toast.error(response.data.msg)
				    }
			    } catch (e) {
				    if (e.response.data.code === 401) {
					    this.forceLogout()
					    return
				    }
				    if (!e.code) {
					    this.$catch_error_response(e);
				    }
			    }
		    },
            ...mapActions({
                fetchBetaFeature: `metaModule/fetchBetaFeature`,
				fetchKomplainQrisMenu: `metaModule/fetchKomplainQrisMenu`,
            }),
	    },
		beforeDestroy () {
            window.removeEventListener('message', this.receiveMessage)
        },
    }
</script>

<style>
    .hidesection {
        display: none;
    }

    #app {
        height: 100vh;
    }

    .full-screen {
        height: 100vh;
    }
	
</style>
